module.exports = __webpack_public_path__ + "static/media/bg-math.69e34c9e.svg";